import React from 'react';
import Divider from 'material-ui/Divider';
import muiThemeable from 'material-ui/styles/muiThemeable';

class TitleBig extends React.Component {

    render() {
        return (
            <div>
                <div style={{
                fontSize:20,
                color: this.props.muiTheme.palette.primary1Color,
                paddingLeft:15,
                paddingBottom:15,
                paddingTop:10}}>
                    {this.props.title}
                </div>
                <Divider/>
            </div>
        );
    }
}

export default muiThemeable()(TitleBig)




// WEBPACK FOOTER //
// ./src/components/shared/utils/TitleBig.js